export const version = "wordlists/5.0.9";
//# sourceMappingURL=_version.js.map